import { useTranslation } from "react-i18next";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";

const StaticLevelPreview = ({ field, level }) => {
  const { t } = useTranslation();

  if (!field || !level) return FIELD_PREVIEW_DEFAULT_VALUE;

  return (
    <div role={field}>{`${level} - ${t(
      `form:staticField:${field}.levels.${level}`
    )}`}</div>
  );
};

export default StaticLevelPreview;
